import { useShowDetailsPanel } from '@confluence/details-panel/entry-points/useShowDetailsPanel.ts';
import { useObjectSidebarActions } from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';

export type DetailsPanelService = {
	showPanel: () => void;
	hidePanel: () => void;
};

export const useDetailsPanelService = () => {
	const { showDetailsPanel } = useShowDetailsPanel();
	const { hideObjectSidebar } = useObjectSidebarActions();

	const detailsPanelService: DetailsPanelService = {
		showPanel: () => {
			showDetailsPanel();
		},
		hidePanel: () => {
			// eslint-disable-next-line @typescript-eslint/no-floating-promises
			hideObjectSidebar();
		},
	};

	return detailsPanelService;
};
